import { Box } from '@mui/material';
import ReactPlayer from 'react-player';

const VideoViewer = ({ videoUrl, purchase }: any) => {
    return (
        <>
            {videoUrl.type === "video" ? (
                <Box sx={styleSheet.mainContainer}>
                    <ReactPlayer
                        url={videoUrl.fileUrl}
                        controls
                        width='100%'
                        height='100%'
                    />
                </Box>
            ) : videoUrl.type === "image" ? (
                // Render Image
                <Box sx={styleSheet.imageContainer}>
                    <img
                        src={videoUrl.fileUrl}
                        alt="Document"
                        style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}

                    />
                </Box>
            ) : (
                <Box sx={styleSheet.pdfContainer}>
                    <iframe
                        src={videoUrl.fileUrl}
                        style={styleSheet.pdfIfram}
                        title="Document Viewer"
                    ></iframe>
                </Box>

            )}
        </>

    );
}

export default VideoViewer;

const styleSheet = {
    mainContainer: {
        // border: '1px solid #E0E0E0',
        borderRadius: '8.46px',
        overflow: 'hidden',
        flexGrow: 1,
        width: { xs: "378px", md: '767px' },
        height: { xs: "293.4px", md: '603px' },

    },
    pdfContainer: {
        border: '1px solid #E0E0E0',
        borderRadius: '8.46px',
        overflow: 'hidden',
        flexGrow: 1,
        backgroundColor: '#f5f5f5',
        height: { xs: "497px", md: '603px' },
    },
    pdfIfram: {
        width: '100%', height: 'calc(100% - 0px)', border: 'none',

    },

    imageContainer: {
        display: "flex",
        width: '100%',
        justifyContent: "center",
        // alignItems: "center",
        backgroundColor: "#f5f5f5",
    },
    image: {
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
    },
}
